import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class PostIndexService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    getAll({root, parent}) {
        return Vue.axios.get(`${APIHOST}/api/postIndex`, {
            params: {
                root: typeof (root) === "boolean" ? root : null,
                parent: typeof (parent) === "number" ? parent : null,

            },
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getWithChilds(id) {
        return Vue.axios.get(`${APIHOST}/api/PostIndexWithChilds`, {
            params: {
                id: id
            },
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    search({root, parent, code}) {
        return Vue.axios.get(`${APIHOST}/api/postIndex`, {
            params: {
                root: typeof (root) === "boolean" ? root : null,
                parent: typeof (parent) === "number" ? parent : null,
                code: typeof (code) === "string" && code.length > 0 ? code : null
            },
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    move({id, parentId}) {
        return Vue.axios.put(`${APIHOST}/api/MovePostIndex`, {ParentId: parentId},
            {
                params: {id: id},
                headers: {
                    "Authorization": `Bearer ${$store.getters.accessToken}`
                }
            });
    }

    update({id, isActive, name, postCode, regionId, areaId}) {
        return Vue.axios.put(`${APIHOST}/api/PostIndex`, {
                Name: name,
                PostCode: postCode,
                RegionId: regionId,
                AreaId: areaId,
                IsActive: isActive
            },
            {
                params: {id: id},
                headers: {
                    "Authorization": `Bearer ${$store.getters.accessToken}`
                }
            });
    }

    searchSimilarPostIndexes({skip, limit, region, area, address}) {
        return Vue.axios.get(`${APIHOST}/api/MailPostIndexRedis`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`,
                'Content-Type': 'application/json'
            },
            params: {
                limit: limit,
                skip: skip,
                regionId: region ? region.id : null,
                areaId: area ? area.id : null,
                address: address ? address : null
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    massAddPostIndex({ids, region, area}) {
        return Vue.axios.post(`${APIHOST}/api/MailPostIndexRedis`, {
            Ids: ids,
            Region: region,
            Area: area
        }, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    updatePostIndex({id, postIndex})
    {
        return Vue.axios.put(`${APIHOST}/api/MailPostIndexRedis`, {
            MailId: id,
            PostCode: postIndex
        }, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    createPostIndex(postIndexRequestModel) {
        return Vue.axios.post(`${APIHOST}/api/PostIndex`, postIndexRequestModel, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            }
        })
    }
}

export default new PostIndexService()
